/**
 * B_Define.js
 *
 * @목적 : B_Define 클래스
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

const B_Define = (function(){

	return class {

		// @DES :: FPS {num} - 초당프레임
		static get FPS() { return 45; }

		// @DES :: defaultSpeed {num} - 기본스피드
		static get SPEED() { return 1; }

		// @DES :: timeIntetval {num} - 시간 간격 (외부접근금지)
		static get INTERVAL() { return 666; }

		// @DES :: ALIAS {json} - 게임 타입별 약자 (문서확인용 => 따로 사용하진 않음)
		static get ALIAS() {
			return {
				'grid' : 'G',
				'isometric' : 'I',
				'select' : 'S',
				'control' : 'C',
				'map' : 'M',
			}
		}

		// @DES :: MESSAGE
		static get MESSAGE() {
			return {
				// UTIL
				"ERROR" : '[코드모스] => 다음 에러를 확인해주세요. :: ',
				// CHILD
				'NO_PARAM' : '[코드모스] => 요청한 자식객체에 파라미터가 없습니다.',
				'NO_CHILD_TYPE' : '[코드모스] => 요청한 자식객체에 타입 파라미터가 없습니다.',
				'NO_CHILD_RES' : '[코드모스] => 요청한 자식객체에 리소스 파라미터가 없습니다.',
				'NO_CHILD_DOM' : '[코드모스] => 요청한 자식객체에 DOM 파라미터가 없습니다.',
				'NO_CANVAS_ID' : '[코드모스] => Canvas ID가 없습니다.',
				'NO_OBJECT_ID' : '[코드모스] => 요청한 자식객체의 아이디가 존재하지 않습니다.',
				'NO_TARGET_OBJECT' : '[코드모스] => 요청한 자식객체의 타겟에 맞는 객체가 없습니다.',
				'CREATE_WORLD_OBJECT' : '[코드모스] => 요청하신 [월드] 자식객체가 생성되었습니다.',
				'CREATE_TOOL_OBJECT' : '[코드모스] => 요청하신 [도구] 자식객체가 생성되었습니다.',
				'`' : '[코드모스] => 요청한 자식객체의 argments에 캔버스 객체가 없습니다.',
				// TOOL
				'NO_POPUP_DOM_OBJECT_ID' : '[코드모스] => 팝업에 Dom ID가 올바르지 않습니다.',
			}
		}

		// ============================ STATE ============================

		// @DES :: PLAY_STATUS {json} - 진행 상태값
		static get PLAY_STATUS() {
			return {
				'PLAY' : true,
				'STOP' : false
			}
		}

		// @DES :: CLEAR_STATUS {json} - 성공 상태값
		static get CLEAR_STATUS() {
			return {
				'FAIL' : 0,
				'SUCCESS' : 1,
				'GOING' : 2
			}
		}

		// @DES :: FAIL {obj} - 실패 이유 객체
		static get REASON() {
			return {
				// === 성공원인 ===
				'SUCCESS'   : 'SUCCESS', // 성공 (종합)

				// === 실패원인 ===
				'FAIL' : 'FAIL', // 실패 (종합)
				'NULL'  : 'NULL', // 없음
				'CRUSH': 'CRUSH', // 충돌
				'FULL': 'FULL', // 가득
				'ORDER': 'ORDER', // 순서
				'LIMIT': 'LIMIT', // 제한
				'WRONG': 'WRONG', // 다름

				// === 진행가능 ===
				'GOING' : 'GOING', // 진행

				// === 진행불가 ===
				'TIMEOVER' : 'TIMEOVER', // 시간초과
				'END' : 'END', // 종료 (종합)
			};
		}

		// ============================ SOUND ============================

		// @DES :: BGM_ID {str}
		static get BGM_ID () { return 'bgm'; }

		// @DES :: BGM_VOLUME {num}
		static get VOLUME_BGM() { return 1; }

		// @DES :: VOLUME_EFFECT {num}
		static get VOLUME_EFFECT() { return 1; }

		// ============================ CHILD ============================

		// @DES :: ARR_RES_TYPE {arr}
		static get ARR_RES_TYPE() { return [
			'image', // 0
			'sprite', // 1
			'graphic', // 2
			'shape', // 3
			'text', // 4
			'dom' // 5
		] }

		// @DES :: bgId {str} - 배경 ID
		static get BG_ID() { return 'mainBG' }

		// @DES :: bgType {str} - 배경 타입
		static get BG_TYPE() { return 'bg' }

		// @DES :: allType {str} - 전체 타입
		static get ALL_TYPE() { return 'all' }

		// @DES :: objType {str} - 객체 타입
		static get OBJ_TYPE() { return 'obj' }

		// @DES :: realType {str} - 물리 타입
		static get REAL_TYPE() { return 'real' }

		// @DES :: unrealType {str} - 논리 타입
		static get UNREAL_TYPE() { return 'unreal' }

		// @DES :: GRID_TYPE {str} - 그리드 타입
		static get GRID_TYPE() { return 'grid' }

		// @DES :: GRID_COLOR {str} - 그리드 색상
		static get GRID_COLOR() { return '#606470'; }

		// @DES :: DECO_TYPE {str} - deco 타입
		static get DECO_TYPE() { return 'deco' }

		// @DES :: SOLUTION_TYPE {str} - 해결책 타입
		static get SOLUTION_TYPE() { return 'solution' }

		// @DES :: TEXT_TYPE {str} - 텍스트 타입
		static get TEXT_TYPE() { return 'text' }

		// @DES :: DOM_TYPE {str} - 텍스트 타입
		static get DOM_TYPE() { return 'dom' }

		// @DES :: LIST - 게임 객체 종류
		static get LIST(){
			return [
				B_Define.ALL_TYPE,
				B_Define.REAL_TYPE,
				B_Define.UNREAL_TYPE,
				B_Define.OBJ_TYPE,
				B_Define.BG_TYPE,
				B_Define.GRID_TYPE,
				B_Define.SOLUTION_TYPE,
				B_Define.TEXT_TYPE,
				B_Define.DECO_TYPE,
				B_Define.DOM_TYPE,
				B_Define.ITEM_SOLUTION_TYPE,
			]
		}

		// ============================ TOOL ============================

		// @DES :: TOOL_IMAGE_FOLDER {str} - 도구 폴더
		static get TOOL_IMAGE_FOLDER() { return '/codmos/static/assets/logicong-study-resources/common/layout' }

		// @DES :: TOOL_IMAGE_SRC {str} - 도구 파일
		static get TOOL_IMAGE_SRC() { return '/canvas_layout-v4.png' }

		// @DES :: TOOL_QUEUE {obj} - 도구 더미
		static get TOOL_QUEUE() {
			return {
				timer : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 166, y : 46, w : 47, h : 16 } }, // 타이머문구
				score : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 252, y : 46, w : 67, h : 16 } }, // 스코어문구
				count : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 70, y : 46, w : 70, h : 16 } }, // 카운드문구
				success : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 159, y : 98, w : 69, h : 69 } }, // 초록동그라미 (성공표시)
				fail : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 263, y : 104, w : 57, h : 57 } }, // 빨간엑스 (실패표시)
				lack : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 369, y : 204, w : 69, h : 69 } }, // 회색동그라미 (부족표시)
				bell : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 18, y : 100, w : 82, h : 64} }, // 벨
				btnTop : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 450, y : 25, w : 62, h : 61 } }, // 위화살표
				btnDown : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 450, y : 101, w : 62, h : 62 } }, // 아래화살표
				btnLeft : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 373, y : 101, w : 63, h : 62} }, // 왼쪽화살표
				btnRight : { src : B_Define.TOOL_IMAGE_SRC, sprite : { x : 526, y : 101, w : 62, h : 62 } }, // 오른쪽화살표
			}
		}

		// @DES :: TOOL_TYPE {str} - 도구 타입
		static get TOOL_TYPE() { return 'tool' }

		// @DES :: MARGIN_TOP - 위쪽 마진
		static get MARGIN_TOP() { return 40;}

		// @DES :: TOOL_TEXT_COLOR - 글자 색상
		static get TOOL_TEXT_COLOR() { return 'black';}

		// @DES :: SCORE_BG - 해더 모양 색상
		static get SHAPE_BG() { return "#ffda52";}

		// @DES :: SHAPE_DEFAULT_WIDTH - 해더 모양 가본 길이
		static get SHAPE_DEFAULT_WIDTH() { return 160; }

		// ====== TOOL (TRY_COUNT) ======

		// @DES :: TRY_COUNT_ID - 시도횟수 객체 id
		static get TRY_COUNT_ID() { return 'tryCount';}

		// @DES :: TRY_COUNT_VIEW_ID - 시도횟수 View 객체 id
		static get TRY_COUNT_VIEW_ID() { return 'tryCountView';}

		// @DES :: TRY_COUNT_ICON_RES - 카운트 아이콘 res
		static get TRY_COUNT_ICON_RES() { return 'count';}

		// @DES :: TRY_COUNT_TEXT_ID - 카운트 글자 id
		static get TRY_COUNT_TEXT_ID() { return '_countText';}

		// @DES :: TRY_COUNT_ICON_ID - 카운트 글자 id
		static get TRY_COUNT_ICON_ID() { return '_countIcon';}

		// @DES :: TRY_COUNT_INIT_VALUE - 카운트 기본값
		static get TRY_COUNT_INIT_VALUE() { return '0/0';}

		// ====== TOOL (SCORE) ======

		// @DES :: SCORE_ID - 스코어 id
		static get SCORE_ID() { return 'score';}

		// @DES :: SCORE_TEXT_ID - 스코어 글자 id
		static get SCORE_TEXT_ID() { return '_scoreText';}

		// @DES :: SCORE_ICON_ID - 스코어 글자 id
		static get SCORE_ICON_ID() { return '_scoreIcon';}

		// @DES :: SCORE_ICON_RES - 스코어 아이콘 res
		static get SCORE_ICON_RES() { return 'score';}

		// @DES :: SCORE_INIT_VALUE - 타이머 기본값
		static get SCORE_INIT_VALUE() { return 0;}

		// ====== TOOL (TIMER) ======

		// @DES :: TIMER_ID - 타이머 id
		static get TIMER_ID() { return 'timer';}

		// @DES :: TIMER_TEXT_ID - 타이머 글자 id
		static get TIMER_TEXT_ID() { return '_timerText';}

		// @DES :: TIMER_ICON_ID - 타이머 글자 id
		static get TIMER_ICON_ID() { return '_timerIcon';}

		// @DES :: TIMER_INIT_VALUE - 타이머 기본값
		static get TIMER_INIT_VALUE() { return '00:00';}

		// @DES :: TIMER_ICON_RES - 타이머 아이콘 res
		static get TIMER_ICON_RES() { return 'timer';}

		// @DES :: TIMER_RES - 타이머 res
		static get TIMER_RES() { return 'timer';}

		// ====== TOOL (BUTTON) ======

		// @DES :: BUTTON_RES - 버튼 res
		static get BUTTON_RES() { return 'bell';}

		// @DES :: BUTTON_ID - 버튼  id
		static get BUTTON_ID() { return 'button';}

		// @DES :: BUTTON_WIDTH - 버튼 크기
		static get BUTTON_WIDTH() { return 65;}

		// @DES :: BUTTON_HEIGHT - 버튼 크기
		static get BUTTON_HEIGHT() { return 50;}

		// ====== TOOL (JOYPAD) ======

		// @DES :: JOYPAD_ID - 조이패드 id
		static get JOYPAD_ID() { return 'joyPad';}

		// @DES :: JOYPAD_WIDTH - 조이패드 가로길이
		static get JOYPAD_WIDTH() { return 150;}

		// @DES :: JOYPAD_HEIGHT - 조이패드 세로길이
		static get JOYPAD_HEIGHT() { return 100;}

		// @DES :: JOYPAD_LENGTH - 조이패드 기준 반지름
		static get JOYPAD_LENGTH() { return 50;}

		// @DES :: JOYPAD_ICON_SIZE
		static get JOYPAD_ICON_SIZE() { return 90;}

		// @DES :: JOYPAD_BTN_LEFT_RES
		static get JOYPAD_BTN_LEFT_RES() { return 'btnLeft';}

		// @DES :: JOYPAD_BTN_RIGHT_RES
		static get JOYPAD_BTN_RIGHT_RES() { return 'btnRight';}

		// @DES :: JOYPAD_BTN_TOP_RES
		static get JOYPAD_BTN_TOP_RES() { return 'btnTop';}

		// @DES :: JOYPAD_BTN_DOWN_RES
		static get JOYPAD_BTN_DOWN_RES() { return 'btnDown';}

		// ====== TOOL (POPUP) ======

		// @DES :: POPUP_ID - 팝업 아이디
		static get POPUP_ID() { return 'popup';}

		// @DES :: POPUP_DOM_OBJECT_ID - 팝업 Dom 아이디
		static get POPUP_DOM_OBJECT_ID() { return '_popupDom';}

		// @DES :: POPUP_DOM_ID - 팝업 Dom 아이디
		static get POPUP_DOM_ID() { return 'canvas-popup';}

		// @DES :: POPUP_TEXT_ALIGN- 팝업 글자 정렬
		static get POPUP_TEXT_ALIGN() { return 'center';}

		// @DES :: POPUP_TEXT_SIZE - 팝업 글자 크기
		static get POPUP_TEXT_SIZE() { return 16;}

		// @DES :: POPUP_TEXT_LINE_HEIGHT - 팝업 글자 크기
		static get POPUP_TEXT_LINE_HEIGHT() { return B_Define.POPUP_TEXT_SIZE + 5;}

		// @DES :: POPUP_DEFAULT_WIDTH - 팝업 기본 너비
		static get POPUP_DEFAULT_WIDTH() { return 300;}

		// @DES :: POPUP_DEFAULT_HEIGHT - 팝업 기본 높이
		static get POPUP_DEFAULT_HEIGHT() { return 200; }

		// @DES :: POPUP_DEFAULT_PADDING - 팝업 기본 패딩
		static get POPUP_DEFAULT_PADDING() { return 20; }

		// @DES :: POPUP_RADIUS - 팝업 Radius
		static get POPUP_RADIUS() { return 10;}

		// @DES :: POPUP_POSITION - 팝업 위치
		static get POPUP_POSITION() { return [ 'BOTTOM', 'TOP' ];}

		// @DES :: POPUP_MOVE_TIME - 팝업 이동 시간
		static get POPUP_MOVE_TIME() { return 500;}

		// @DES :: POPUP_COLOR_BG - 팝업 배경 색상
		static get POPUP_COLOR_BG() { return '#fffcea';}

		// @DES :: POPUP_COLOR - 팝업 악센트 색상
		static get POPUP_COLOR() {
			return {
				'null'    : '#fffcea',
				'success' : '#00a651',
				'danger'  : '#ed1c24',
			}
		}

		// ====== TOOL (DISABLED) ======

		// @DES :: DISABLED_ID - 비활성화 아이디
		static get DISABLED_ID() { return '_disabled'; }

		// @DES :: DISABLED_ALPHA_DARK - 비활성화 투명도 (진함)
		static get DISABLED_ALPHA_DARK() { return 0.3; }

		// @DES :: DISABLED_ALPHA_SOFT - 비활성화 투명도 (연함)
		static get DISABLED_ALPHA_SOFT() { return 0.01; }

		// @DES :: DISABLED_COLOR - 비활성화 투명도
		static get DISABLED_COLOR() { return '#000000'; }

		// ====== TOOL (COUNT-DOWN) ======

		static get COUNTDOWN_ID() { return 'countdown' }

		static get COUNTDOWN_INIT_TIME() { return 3 }

		static get COUNTDOWN_ANIMATE_TIME() { return 500; }

		static get COUNTDOWN_BIG_SCALE() { return 20; }

		// ====== TOOL (SUCCESS & FAIL) ======

		// @DES :: MARK_SUCCESS_RES
		static get MARK_SUCCESS_RES() { return 'success';}

		// @DES :: MARK_FAIL_RES
		static get MARK_FAIL_RES() { return 'fail';}

		// @DES :: MARK_LACK_RES
		static get MARK_LACK_RES() { return 'lack';}

		// ============================ TRANSACTION ============================

		// @DES :: MOVE_DISTANCE {num}
		static get MOVE_DISTANCE() { return 1; }

		// @DES :: ACTION_MOVE {str}
		static get ACTION_MOVE() { return 'move'; }

		// @DES :: JUMP_DISTANCE {num}
		static get JUMP_DISTANCE() { return 2; }

		// @DES :: ACTION_JUMP {str}
		static get ACTION_JUMP() { return 'jump'; }

		// @DES :: DEFAULT_ROTATE - 기본 회전방향
		static get DEFAULT_ROTATE() { return 180; }

		// ============================ EFFECT ============================

		// @DES :: FIREWORK_DUMMY {json} - 폭죽 이벤트 속성 (proton)
		static get FIREWORK_DUMMY_RED() {
			return 	{
				color: ['yellow', 'pink', 'white'],
				count: [30, 30],
				size: [2, 4],
				time: 0.2,
				speed: [B_Define.INTERVAL / 5, B_Define.INTERVAL]
			}
		}

		// @DES :: FIREWORK_DUMMY {json} - 폭죽 이벤트 속성 (proton)
		static get FIREWORK_DUMMY_BLUE() {
			return 	{
				color: ['skyblue', 'aqua', 'white'],
				count: [30, 30],
				size: [2, 4],
				time: 0.2,
				speed: [B_Define.INTERVAL / 5, B_Define.INTERVAL]
			}
		}

		// ============================ DOM ============================

		// @DES :: DOM_CANVAS_WRAPPER_ID {str}
		static get DOM_CANVAS_WRAPPER_ID() {
			return 'canvas-wrapper'
		}

		// @DES :: DOM_CANVAS_WRAPPER {arr} - DOM 객체가 들어가기 위해서 캔버스를 감싸는 DOM
		// static get DOM_CANVAS_WRAPPER() {
		// 	return [ "<div id='" + B_Define.DOM_CANVAS_WRAPPER_ID + "' style='display: inline-block'>", "</div>" ]
		// }

		// @DES :: VARIABLE_REAL_TYPE {str} - 실제 변수 (보이지 않음)
		static get VARIABLE_REAL_TYPE () { return 'variableReal' }

		// @DES :: VARIABLE_TYPE {str} - 실제 변수를 참조함 {보임}
		static get VARIABLE_TYPE () { return 'variable' }

		// @DES :: ITEM_SOLUTION_TYPE {str} - 아이템을 획득한 후 처리 되는 해결책 타입
		static get ITEM_SOLUTION_TYPE () { return 'itemSolution'; }
	}
}());

export default B_Define;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/util/B_Define.js